module.exports = __webpack_public_path__ + "static/media/ideia.5ed1c0ef.svg";